import { Controller } from "@hotwired/stimulus"
import InfiniteScroll from 'infinite-scroll'

export default class extends Controller {
    static get targets() {
        return ["appendContainer", "footer", "viewMoreButton", "pageLoadStatus"]
    }

    static get values() {
        return {
            selector: String
        }
    }

    connect() {
        let infScroll;

        infScroll = new InfiniteScroll(this.appendContainerTarget, {
            path: this.selectorValue + ' [aria-label="Next"]',
            append: this.selectorValue + ' .infinite-scroll-element',
            scrollThreshold: false,
            status: this.pageLoadStatusTarget,
            button: this.viewMoreButtonTarget,
            history: true
        })

        this.viewMoreButtonTarget.style.display = 'inline-flex'

        if (infScroll) {
            infScroll.on('request', (path, fetchPromise) => {
                this.toggleLoadingButton();
            });

            infScroll.on('append', (path, fetchPromise) => {
                this.toggleLoadingButton();
            });

            // When new content is appended, re-layout the gallery to ensure new photos position correctly
            // Dispatch
            infScroll.on('append', (event, response, path, items) => {
                // note: the 'event' here is the jQuery event, the dispatch below will also dispatch with its own event
                // passing the original jQuery event (which is not strictly a DOM event) in the detail as it may be used
                const detail = { event, response, path, items };

                this.dispatch('append', {
                    cancelable: false,
                    detail,
                    target: event.target,
                });
            })
        }
    }

    toggleLoadingButton() {
        let i = this.viewMoreButtonTarget.querySelector('i');
    
        if (i.classList.contains('loading')) {
            i.classList.remove('loading');
            if (i.dataset.originalClass) {
                i.classList.add(i.dataset.originalClass);
            }
            this.viewMoreButtonTarget.removeAttribute('disabled');
        } else {
            let currentClass = [...i.classList].find(cls => cls !== 'loading'); // Find the existing class
            if (currentClass) {
                i.dataset.originalClass = currentClass; // Store the original class
                i.classList.remove(currentClass);
            }
            i.classList.add('loading');
            this.viewMoreButtonTarget.setAttribute('disabled', 'disabled')
        }
    }
}
